import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CommonContainer } from './styles';
import Form from '../../../shared/enquiry/form';
import Success from '../../../shared/enquiry/success';
import EnquiryContext from '../../../shared/enquiry/context';
import { Separator } from '../../../shared/sectionable/styles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  border: 1px solid #E5EAEE;
  border-radius: 6px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  background-color: ${props => props.theme.bodyBackgroundColor};
  padding: 32px 24px 48px;
  margin-bottom: -176px;

  ${props => props.theme.isMobile && `
    padding: 32px 16px;
    margin-bottom: -160px;
  `};
`;

const Title = styled.div`
  color: ${props => props.theme.bodyColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 29px;
  font-weight: 700;
  line-height: 120%;
`;

const SubTitle = styled.div`
  color: ${props => props.theme.bodyColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 20px;
  font-weight: 700;
  line-height: 110%;
  text-transform: uppercase;
`;

const SSeparator = styled(Separator)`
  margin-top: 16px;
`;

const sectionName = 'enquiry';
export default function Enquiry({ fund, investorTypes }) {
  const { state: { showEnquiryForm, contactSent } } = React.useContext(EnquiryContext);

  const referable = { ...fund, type: 'Fund' };

  if (!fund.activePartnership) {
    return null;
  }

  return (
    <CommonContainer>
      <Container id={sectionName} name={sectionName}>
        <SubTitle>Enquiry form</SubTitle>
        <Title>{fund.name}</Title>
        <SSeparator />
        {showEnquiryForm && !contactSent
        && <Form referable={referable} investorTypes={investorTypes} messageToLabel="MESSAGE TO FUND MANAGER (Optional)" />}
        {contactSent && <Success organization={fund.company.name} />}
      </Container>
    </CommonContainer>
  );
}

Enquiry.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    company: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    activePartnership: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  }).isRequired,
  investorTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
};
